export default __webpack_public_path__ + "static/media/i-stack-3.0d934c70.svg";